import React, { useContext, useCallback } from "react";
import { modalTypes } from "../../constants";
import * as actionTypes from "./actionTypes";
import modalsReducer, { initialState } from "./modalsReducer";
import EditTaskModal from "../../containers/EditTaskModal";

const ModalsContext = React.createContext();

const ModalsProvider = ({ children }) => {
  const [{ modalType, payload }, dispatch] = React.useReducer(modalsReducer, initialState);

  const openModal = useCallback((modalType, payload) => {
    dispatch({ 
      type: actionTypes.OPEN_MODAL,
      modalType,
      payload,
    });
  }, [dispatch]);

  const closeModal = useCallback(() => {
    dispatch({ type: actionTypes.CLOSE_MODAL });
  }, [dispatch]);

  return (
    <ModalsContext.Provider
      value={{
        openModal,
        closeModal,
      }}
    >
      {children}

      {modalType === modalTypes.EDIT_TASK_MODAL && (
        <EditTaskModal {...payload} />
      )}
    </ModalsContext.Provider>
  );
};

export const useModals = () => {
  const context = useContext(ModalsContext);

  if (context === undefined) {
    throw new Error("useModals must be used within a ModalsProvider");
  }

  return context;
};

export default ModalsProvider;
